<form style="width: 100%;">
  <mat-form-field class="form-element filterList" style="width: 100%;">
    @if (!hideLabel) {
      <mat-label>{{'placeholder.createCategory' | transloco}}</mat-label>
    }
    <input type="text" matInput
      inputrestriction="basic2"
      name="SearchDualList"
      (keyup)="onKeyupCategory()"
      [formControl]="frmCategory"
      [matAutocomplete]="auto">
      <a matSuffix aria-label="Clear" (click)="clearSelection()">
        <mat-icon>close</mat-icon>
      </a>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectionChange($event)">
        @for (cate of filteredCategories | async; track cate) {
          <mat-option [value]="cate">
            {{cate}}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </form>
